import React from 'react'
import HeroSection from '../components/HeroSection'
import PopularDestinations from '../components/PopularDestinations'
import TopRatedHotels from '../components/TopRatedHotels'
import SpecialOffers from '../components/SpecialOffers'
import LatestBlogs from '../components/LatestBlogs'
import FaqSection from '../components/FaqSection'
import DefaultSEO from "../components/DefaultSEO";

const HomePage = () => {
  return (
    <div>
      <DefaultSEO>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "ZoyoTrip",
              "url": "https://www.zoyotrip.com",
              "logo": "https://www.zoyotrip.com/logo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8978675646",
                "contactType": "customer service",
                "areaServed": "IN",
                "availableLanguage": ["en", "hi"]
              }
            }
          `}
        </script>
      </DefaultSEO>
      <HeroSection />
      <PopularDestinations />
      <TopRatedHotels />
      <SpecialOffers />
      <LatestBlogs />
      <FaqSection />
    </div>
  )
}

export default HomePage